import { Controller } from "@hotwired/stimulus";

// A page refresh triggered by PollInstance#broadcast_response_refresh morphs
// this form back to server-rendered markup, which idiomorph uses to sync the
// live `checked` property on every checkbox: the server still thinks the
// member holds whatever is saved, so a tick or untick made but not yet
// submitted would otherwise be overwritten in either direction. Record the
// full ticked set on every change and reassert it authoritatively once the
// morph settles, so an in-progress selection (including an untick of an
// already-saved answer) survives someone else filling a different answer
// while the sheet is open. A checkbox the server now disables is never
// touched, since the member cannot act on it either way.
export default class extends Controller {
  static targets = ["checkbox"];

  record() {
    this.ticked = this.checkboxTargets
      .filter((checkbox) => checkbox.checked)
      .map((checkbox) => checkbox.value);
  }

  restore() {
    if (!this.ticked) return;

    this.checkboxTargets.forEach((checkbox) => {
      if (checkbox.disabled) return;

      checkbox.checked = this.ticked.includes(checkbox.value);
    });
  }
}
